import { StrictMode, DetailedHTMLProps, HTMLAttributes } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nProvider } from '@lingui/react';
import {
  defineCustomElements,
  JSX,
} from '@swisscom/sdx/dist/js/webcomponents/loader';
// @ts-ignore
import { setAssetPath } from '@swisscom/sdx/dist/js/webcomponents/esm';
import '@swisscom/sdx/dist/css/webcomponents.min.css';
import './styles/globals.css';
import { i18n } from './i18n';
import App from './App';
import { setupAxiosAuth } from './auth/axiosAuth';
import reportWebVitals from './reportWebVitals';

// Register the Stencil types
type StencilProps<T> = {
  [P in keyof T]?: Omit<T[P], 'ref'> | HTMLAttributes<T>;
};

// Register the React types
type ReactProps<T> = {
  [P in keyof T]?: DetailedHTMLProps<HTMLAttributes<T[P]>, T[P]>;
};

// Combine both types
type StencilToReact<
  T = JSX.IntrinsicElements,
  U = HTMLElementTagNameMap,
> = StencilProps<T> & ReactProps<U>;

// Export the new types as the new JSX namespace.
// Disable the eslint errors
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  export namespace JSX {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface IntrinsicElements extends StencilToReact {}
  }
}

const container = document.getElementById('root');
if (container) {
  setupAxiosAuth();
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <I18nProvider i18n={i18n}>
        <App />
      </I18nProvider>
    </StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// @ts-ignore because of wrong type in stencil package
defineCustomElements().then(() =>
  setAssetPath(`${window.location.protocol}//assets.${window.location.host}/`),
);
